import { render, staticRenderFns } from "./TransitionSharp.vue?vue&type=template&id=0c774829&scoped=true"
import script from "./TransitionSharp.vue?vue&type=script&lang=ts"
export * from "./TransitionSharp.vue?vue&type=script&lang=ts"
import style0 from "./TransitionSharp.vue?vue&type=style&index=0&id=0c774829&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c774829",
  null
  
)

export default component.exports